import { createFileRoute } from '@tanstack/react-router';
import { CustomerScreen, customerSearchSchema } from '../../../features/customers/customer-screen';

/**
 * Adăugarea are rută proprie, nu un `?nou=1` peste listă: formularul e la fel de mare ca
 * fișa, iar o adresă proprie înseamnă că butonul „Înapoi" al browserului face exact ce
 * așteaptă operatorul — se întoarce la listă, nu iese din aplicație.
 *
 * `/clienti/nou` stă înaintea lui `/clienti/$customerId` în arborele generat: rutele
 * statice bat parametrii, deci „nou" nu poate fi citit ca id de client.
 *
 * Tabul e în URL, ca pe fișă: același ecran, aceleași reguli. Pe un client nesalvat
 * celelalte taburi spun că n-au ce arăta încă, dar rămân apăsabile — și rămân deschise
 * peste un refresh.
 */
export const Route = createFileRoute('/_authenticated/clienti/nou')({
  validateSearch: customerSearchSchema,
  component: ClientNou,
});

function ClientNou() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CustomerScreen
      tab={tab}
      onTabChange={(next) => navigate({ search: { tab: next }, replace: true })}
    />
  );
}
